import { isDefined } from 'notable-common';
import { z } from 'zod';
import { flowConditionalConfigSchema } from '../conditional/conditionalConfig.js';
export var FlowBlockEventTrigger;
(function (FlowBlockEventTrigger) {
    FlowBlockEventTrigger["OnBlockCompleted"] = "OnBlockCompleted";
    FlowBlockEventTrigger["OnBlockError"] = "OnBlockError";
})(FlowBlockEventTrigger || (FlowBlockEventTrigger = {}));
export var FlowRunAnalyticEventCategory;
(function (FlowRunAnalyticEventCategory) {
    FlowRunAnalyticEventCategory["Authorizations"] = "Authorizations";
    FlowRunAnalyticEventCategory["ReferralTranscription"] = "ReferralTranscription";
    FlowRunAnalyticEventCategory["IntakePayments"] = "IntakePayments";
    FlowRunAnalyticEventCategory["ReferralScheduling"] = "ReferralScheduling";
    FlowRunAnalyticEventCategory["CareGaps"] = "CareGaps";
    FlowRunAnalyticEventCategory["HccSuspecting"] = "HccSuspecting";
    FlowRunAnalyticEventCategory["OutboundScheduling"] = "OutboundScheduling";
    FlowRunAnalyticEventCategory["Custom"] = "Custom";
})(FlowRunAnalyticEventCategory || (FlowRunAnalyticEventCategory = {}));
export const BaseFlowBlockEventDefinitionSchema = z
    .object({
    id: z.string().min(1),
    name: z.string().min(1).optional(),
    trigger: z.enum(FlowBlockEventTrigger),
    customAttributes: z
        .array(z.object({ key: z.string().min(1), value: z.string().min(1) }))
        .optional(),
    category: z
        .enum(FlowRunAnalyticEventCategory)
        .optional()
        .default(FlowRunAnalyticEventCategory.Custom),
    standardAnalyticEventId: z.uuid().optional(),
    conditions: flowConditionalConfigSchema.optional(),
})
    .refine((data) => {
    return isDefined(data.name) || isDefined(data.standardAnalyticEventId);
}, {
    message: "Either 'name' or 'standardAnalyticEventId' must be provided",
});
//# sourceMappingURL=event.js.map